import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoginService } from '../services/login.service';
import { LoginResponseBody } from '../../models/types';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { RouteName } from '../../models/enums';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser, faLock, faEnvelope, faAddressBook, faPhone, faXmark, faList} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-admin-login',
  standalone: true,
  imports: [CommonModule, FormsModule, FormsModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './admin-login.component.html',
  styleUrl: './admin-login.component.scss'
})
export class AdminLoginComponent {
  isLoggingIn = false;
  faLock = faLock;
  faUser = faUser;

  loginFormGroup: FormGroup = new FormGroup({
    username: new FormControl("", [Validators.required]),
    password: new FormControl("", [Validators.required])
  })

  get username() {
    return this.loginFormGroup.get("username");
  }

  get password() {
    return this.loginFormGroup.get("password");
  }

  constructor(
    private loginService: LoginService,
    private router: Router,
  ) {}

  OnLoginPressed() {
    if(!this.loginFormGroup.valid) {
      return;
    }
    this.isLoggingIn = true;
    this.loginService.SendLoginInfo({
      password: this.password!.value,
      username: this.username!.value,
      is_admin: true,
    }).subscribe({
      next: (data) => {
        const response: LoginResponseBody = data.body as LoginResponseBody
        this.loginService.SetToken(response.token);
        this.router.navigate([RouteName.dashboard]);
        this.loginService.onUserLoggedIn.emit();
        Swal.fire({
          title: "Uspešna prijava",
          text: "Uspešno ste se prijavili",
          icon: "success",
          showConfirmButton: false,
          timer: 1000
        })
        this.router.navigate([RouteName.home])
      },
      error: (err) => {
        console.log(err)
        this.isLoggingIn = false;
        switch(err.status) {
          case 401:
            Swal.fire({
              title: "Napaka pri prijavi",
              text: "Vnesli ste napačno uporabniško ime ali geslo",
              icon: "error",
              showConfirmButton: true,
              confirmButtonText: "Zapri"
            })
            break;
              default:
              Swal.fire({
                title: "Napaka pri prijavi",
                text: "Neznana napaka, prosim poskusite kasneje",
                icon: "error",
                showConfirmButton: true,
                confirmButtonText: "Zapri"
              })
              break;
        }
      }
    })
  }

  OnEnterPressed() {
    this.OnLoginPressed();
  }
}
